/* prodig-rental-inquiry-webhook
   /pages/contact から業務管理システム (= BMS) へ POST し、見込案件を自動起票する。
   Shopify 標準 contact フォームは注文にならず webhook も無いため、フォーム側で発火する。

   受け口: https://bms.prodig.co.jp/api/integrations/rental/inquiry
   2026-09-02 に送り先をレンタル管理システムから BMS へ移した (= BMS の ADR-0045)。
   レンタル管理システムは BMS へ統合して畳む (= ADR-0018) ので、そちらへ送ると
   案件が BMS に来ない (= 移行コマンドを回すまで営業から見えない) ため。
   業務管理の本番 (bms.prodig.co.jp、2026-10-27 に名乗りを変更。旧 bms-staging も同じ実体)。
   rental.prodig.co.jp は Shopify 本体なので /api は届かない
   (= 2026-08-14 に廃止した旧 URL。正しいホストは管理画面側)。

   発火は submit 時ではなく「Shopify が送信を受理して posted_successfully で再描画した時」。
   submit の既定動作は Shopify 標準の captcha (hCaptcha) が握っていて、チャレンジが出た場合や
   captcha スクリプトの読み込みに失敗した場合は Shopify へ届かないまま画面に留まる。
   submit 時点で POST すると、その届かなかった送信まで案件になる
   (2026-08-18: 案件だけ増えて問い合わせメールも Chatwork 通知も来ない事象)。
   そのため submit では sessionStorage に控えるだけにして、受理が確定してから送る。

   Chatwork 通知 (メール → Gmail → GAS) は別経路のまま動かす。
   この POST が失敗しても問い合わせ自体は成立している。 */
(function () {
  'use strict';
  if (window.ProdigRentalInquiryWebhook) return;

  var ENDPOINT = 'https://bms.prodig.co.jp/api/integrations/rental/inquiry';
  var STORAGE_KEY = 'prodig_rental_pending_inquiry';
  var CIRCLE = ['①', '②', '③', '④'];

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function formatReceivedAt(d) {
    return d.getFullYear() + '/' + pad2(d.getMonth() + 1) + '/' + pad2(d.getDate())
      + ' ' + pad2(d.getHours()) + ':' + pad2(d.getMinutes()) + ':' + pad2(d.getSeconds());
  }

  function val(form, name) {
    var nodes = form.querySelectorAll('[name="contact[' + name + ']"]');
    if (!nodes.length) return '';
    if (nodes[0].type === 'radio') {
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].checked) return (nodes[i].value || '').trim();
      }
      return '';
    }
    return (nodes[0].value || '').trim();
  }

  function firstVal(form, names) {
    for (var i = 0; i < names.length; i++) {
      var v = val(form, names[i]);
      if (v) return v;
    }
    return '';
  }

  function itemsFromCart() {
    var Cart = window.ProdigRentalCart;
    var lines = (Cart && typeof Cart.load === 'function') ? Cart.load() : [];
    var items = [];
    for (var i = 0; i < lines.length; i++) {
      var l = lines[i];
      var days = (Cart.lineDays) ? Cart.lineDays(l) : 0;
      var unit = (Cart.perUnit && l.cp) ? Cart.perUnit(days, l.cp) : null;
      items.push({
        name: l.name,
        quantity: l.qty,
        start: l.start,
        end: l.end,
        maker: l.maker || '',
        unit_amount: unit,
        amount: (unit && l.qty) ? unit * l.qty : null
      });
    }
    return items;
  }

  function itemsFromForm(form) {
    var items = [];
    for (var i = 0; i < CIRCLE.length; i++) {
      var name = val(form, '希望機種' + CIRCLE[i]);
      var qty = Number(val(form, '台数' + CIRCLE[i]));
      if (!name) continue;
      items.push({
        name: name,
        quantity: (isFinite(qty) && qty > 0) ? Math.floor(qty) : 0
      });
    }
    return items;
  }

  function buildPayload(form) {
    var items = itemsFromCart();
    if (!items.length) items = itemsFromForm(form);
    var start = items.length && items[0].start ? items[0].start : val(form, '開始日');
    var end = items.length && items[0].end ? items[0].end : val(form, '終了日');
    var kind = val(form, 'ご希望の内容');
    var inquiryType = val(form, 'お問い合わせ種別') || 'レンタルお問い合わせ';
    if (kind) inquiryType = inquiryType + '（' + kind + '）';

    return {
      received_at: formatReceivedAt(new Date()),
      inquiry_type: inquiryType,
      request_kind: kind,
      source_page: val(form, '送信元ページ') || (location.pathname || ''),
      company_name: firstVal(form, ['会社名・団体名', '会社名']),
      company_url: val(form, '会社URL'),
      department: firstVal(form, ['部署名', '部署名・役職']),
      postal_code: val(form, '郵便番号'),
      address: val(form, '住所'),
      contact_name: firstVal(form, ['ご担当者名・氏名', 'name']),
      contact_kana: val(form, 'ご担当者名・氏名（カナ）'),
      /* 資料ダウンロードのフォームだけにある項目 (= 2026-09-15。無ければ空) */
      document_name: val(form, '資料名'),
      purpose: val(form, '検討中の用途'),
      email: val(form, 'email'),
      phone: val(form, '電話番号'),
      start_date: start,
      end_date: end,
      items: items,
      body: val(form, 'body'),
      _hp: ''
    };
  }

  /* CORS 事前確認 (OPTIONS) の先出し。
     application/json の POST は事前確認が必要で、送信ボタン押下時に初めて出すと
     Shopify への遷移が先に走って fetch ごと消える (= 案件が 1 件も届かない)。
     入力開始の時点で一度 POST しておくと、受け口が返す Access-Control-Max-Age
     (86400) でブラウザが事前確認を覚えるため、送信時は POST 1 本だけになり
     keepalive で遷移をまたげる。
     company_name 無しの POST は受け口が 400 で返すだけで、案件は作られない。 */
  var warmed = false;

  function warmUp() {
    if (warmed) return;
    warmed = true;
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
        mode: 'cors'
      }).catch(function () { /* noop */ });
    } catch (e) { /* noop */ }
  }

  /* submit 時点の入力内容を控えるだけ。 captcha で送信が止まった場合はここで終わり、
     案件は作られない (控えは同じタブの sessionStorage にしか残らない)。 */
  function stash(form) {
    try {
      if (!form) return;
      var payload = buildPayload(form);
      if (!payload.company_name) return;
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) { /* noop */ }
  }

  /* Shopify が受理した後に控えを送る。 二重起票を防ぐため読み出しと同時に消す。
     サンクスページへの遷移をまたげるよう keepalive を付ける
     (CORS 事前確認は入力開始時の warmUp で済んでいるので POST 1 本で足りる)。 */
  function flush() {
    var raw = null;
    try {
      raw = sessionStorage.getItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) { /* noop */ }
    if (!raw) return Promise.resolve();
    try {
      return fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: raw,
        mode: 'cors',
        keepalive: true
      }).catch(function () { /* noop */ });
    } catch (e) {
      return Promise.resolve();
    }
  }

  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/contact"]')) warmUp();
  });

  window.ProdigRentalInquiryWebhook = {
    ENDPOINT: ENDPOINT,
    stash: stash,
    flush: flush,
    warmUp: warmUp,
    buildPayload: buildPayload
  };

  /* 成功時の再描画で立つフラグ (セクション側のインラインスクリプトが先に走る)。
     POST の完了を待ってからサンクスページへ送るが、待ちが伸びると離脱に見えるので
     セクション側の予備タイマーと合わせて頭打ちにする。 */
  if (window.ProdigRentalInquiryPosted) {
    var redirected = false;
    var go = function () {
      if (redirected) return;
      redirected = true;
      if (typeof window.ProdigRentalInquiryRedirect === 'function') {
        window.ProdigRentalInquiryRedirect();
      }
    };
    setTimeout(go, 1200);
    flush().then(go, go);
  }
})();
